module.exports = __webpack_public_path__ + "static/media/WebText_SpecialMove_Prinny2_2.d5c30141.png";